import { render, staticRenderFns } from "./Inspectors.vue?vue&type=template&id=7a608355&scoped=true"
import script from "./Inspectors.vue?vue&type=script&lang=ts"
export * from "./Inspectors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a608355",
  null
  
)

export default component.exports